import { Component, inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CompanyCategoryDTO } from 'src/app/Common/CompanyCategoryService/CompanyCategory.interface';
import { CompanycategoryService } from 'src/app/Common/CompanyCategoryService/companycategory.service';

@Component({
  selector: 'app-category-selector',
  templateUrl: './category-selector.component.html',
  styleUrls: ['./category-selector.component.css']
})
export class CategorySelectorComponent {

  @Input({ required: true }) control!: FormControl
  companyCategoryService = inject(CompanycategoryService)


  categoryChange(e: CompanyCategoryDTO) {
    this.companyCategoryService.updateSubCategories(e.categoryId)

  }

}
